import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LogmanagementService } from '../components/logmanagement/logmanagement.service';

@Component({
  selector: 'app-sale-volume-compare',
  templateUrl: './sale-volume-compare.component.html',
  styleUrl: './sale-volume-compare.component.scss'
})
export class SaleVolumeCompareComponent  implements OnInit {
  sourceDropdownOptions: any[];
  constructor( private logmanagementservice: LogmanagementService,private cdRef: ChangeDetectorRef,) { }
  loader: boolean = false;
  selectedSource:any;
  rawData: any[][] = []; // Your full nested array
  flattenedData: any[] = [];
  tableHeaders: string[] = [];
  ngOnInit(): void {
    this.getNdaSaleData()
  }
  getNdaSaleData(){
    try{
      this.loader=true;
      this.logmanagementservice.getNdaSaleData().subscribe((response) => {
        if (response.data.nda_numbers) {
          this.sourceDropdownOptions = [
            {
              label: 'Select NDA',
              value: null
            },
            ...response.data.nda_numbers.map((item) => ({
              ...item,
              label: item.brand_name,
              value: item
            }))
          ];
        }
        this.loader = false;
      },
        (error) => {
          console.error('Error fetching data', error);
          this.loader = false;  // Hide loader on error
        });
    }catch{
      this.loader = false;

    }
    finally{
      this.loader = false;
    }
  }


  onDropdownChange() {
    if(this.selectedSource){
      this.logmanagementservice.postNdaSaleDatatAPI(this.selectedSource).subscribe(async(response:any) => {
        // Flatten the nested arrays
        if(response && response?.data && response?.data?.[0] && response?.data?.[0]?.data){
          this.rawData= response?.data?.[0]?.data;
          this.flattenedData =await this.rawData.reduce((acc, val) => acc.concat(val), []);
          const allKeys = new Set<string>();
         await this.flattenedData.forEach(item => {
            Object.keys(item).forEach(key => allKeys.add(key));
          });
        
          this.tableHeaders = Array.from(allKeys);
         await this.cdRef.detectChanges();

        }
        else{
          this.flattenedData=[];
          this.cdRef.detectChanges();
        }


    })
    }
  }

}
